module.exports = "\n    <div class=\"backlink-box button-box\">\n        <a class=\"mbgf-form-button mbgf-arrow-left mbgf-btnBackOverview\" href=\"{{backlink.buttonLink}}\" runat=\"server\">{{backlink.buttonText}}</a>\n    </div>\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./js-src/markdown-editor/modules/backlink/backlink.html
// module id = 293
// module chunks = 0 1